var bilder = (function () {
  function doljTomBildtext() {
    document
      .querySelectorAll(".qbankmediawrapper .bildText")
      .forEach(function (elem) {
        var bildText = elem.querySelector("p");
        if (
          bildText !== null &&
          bildText.textContent !== null &&
          bildText.textContent.trim().length == 0
        ) {
          bildText.classList.add("d-none");
        }
      });
  }

  /* ********** Exponerade funktioner     */
  function initBilder() {
    doljTomBildtext();
  }

  return {
    initBilder: initBilder,
  };
})();

export default bilder;
